import GlobalPageSupport = Infospeed.Services.ClassWeb.API.Contracts.COT.GlobalPageSupport;

import { Component, OnInit } from '@angular/core';
import { BaseCotFormComponent } from '../../../components/base-cot-form.component';
import { HarrowHeaderService } from './harrow-header.service';

@Component({
    selector: 'harrow-header',
    templateUrl: './harrow-header.component.html',
    styleUrls: ['./harrow-header.component.scss']
})
export class HarrowHeaderComponent extends BaseCotFormComponent implements OnInit {
    siteAddress: string = '';

    constructor(private harrowHeaderService: HarrowHeaderService) {
        super();
    }

    ngOnInit() {
        this.harrowHeaderService.getHeaderData().takeUntil(this.emitUnsubscribe).subscribe(
            (data: GlobalPageSupport) => {
                this.siteAddress = data.SiteAddress;
            },
            (error: any) => {
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/customizations/harrow/header/harrow-header.component.ts